import React, { useCallback } from 'react';
import addDays from 'date-fns/addDays';
import { BlackoutDates } from './../../../../containers/VerticalBookingContainer/blackoutDates';
import { isInUnavailableFetchDates } from './../../../../../components/lab/DateRangePicker/useDatePicker/useBlackoutDates/util';
import { useDatePickerI18n } from './../../datePickerI18n';
import { formatDate } from '../../../../../components/lab/utils';

interface UseDayProps {
  date: Date;
  focusedDate: Date | null;
  isDateFocused(date: Date): boolean;
  isDateSelected(date: Date): boolean;
  isDateHovered(date: Date): boolean;
  isDateBlocked(date: Date): boolean;
  isFirstOrLastSelectedDate(date: Date): boolean;
  onDateFocus(date: Date): void;
  onDateSelect(date: Date): void;
  onDateHover(date: Date): void;
  blackoutDatesIntegration?: boolean;
  fetchBlackoutDates?: BlackoutDates | null;
  focusedInput?: string | null;

  // Not used anymore
  dayRef?: React.RefObject<HTMLButtonElement>;
}

function useDay({
  date,
  focusedDate,
  isDateSelected,
  isDateFocused,
  isFirstOrLastSelectedDate,
  isDateHovered,
  isDateBlocked,
  onDateSelect,
  onDateFocus,
  onDateHover,
  blackoutDatesIntegration = false,
  fetchBlackoutDates = {},
  focusedInput = ''
}: UseDayProps) {
  const { format = formatDate } = useDatePickerI18n();
  const onClick = useCallback(() => onDateSelect(date), [date, onDateSelect]);
  const onMouseEnter = useCallback(() => onDateHover(date), [date, onDateHover]);
  const disabled = isDateBlocked(date) && !isDateHovered(date);

  return {
    tabIndex: focusedDate === null || isDateFocused(date) ? 0 : -1,
    isSelected: isDateSelected(date),
    isSelectedStartOrEnd: isFirstOrLastSelectedDate(date),
    isSelectedStartOrEndAndBlackout: blackoutDatesIntegration
      ? isInUnavailableFetchDates(fetchBlackoutDates, date, focusedInput, format) &&
        isFirstOrLastSelectedDate(date)
      : false,
    isAMiddleAndBlackout: blackoutDatesIntegration
      ? isInUnavailableFetchDates(fetchBlackoutDates, date, focusedInput, format) &&
        isDateSelected(date) &&
        !isFirstOrLastSelectedDate(date)
      : false,
    isWithinHoverRange: isDateHovered(date),
    disabledDate: disabled,
    onKeyDown: (e: React.KeyboardEvent<HTMLButtonElement>) => {
      if (e.key === 'ArrowRight') {
        onDateFocus(addDays(date, 1));
      } else if (e.key === 'ArrowLeft') {
        onDateFocus(addDays(date, -1));
      } else if (e.key === 'ArrowUp') {
        onDateFocus(addDays(date, -7));
      } else if (e.key === 'ArrowDown') {
        onDateFocus(addDays(date, 7));
      }
    },
    onClick: disabled ? () => {} : onClick,
    onMouseEnter
  };
}

export default useDay;
